import React from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import MenuHelper from "../../../../helpers/MenuHelper";
import { NavLink } from "react-router-dom";

const LableIconNav = (props) => {

    return (
        <>
            {props?.v.status && !Object.values(props.menuList).some((submenu) => submenu.parent_menu_code === props?.v.code) &&
                !(props?.v.location == "sub_menu" && !props?.v.parent_menu_code) ? (
                <li className="label-icon-menu" key={props?.v.code}>
                    <NavLink to={props?.customLink} onMouseOver={() => props?.mouseOver(props?.v.code)}>
                        <span>
                            <MenuHelper t={props.t} ftpPath={props?.playerMenu?.ftp_path} data={props?.v} className={""} />
                        </span>
                    </NavLink>
                </li>
            ) : null}
        </>
    );
};

LableIconNav.propTypes = {
    preGlobalFilteredRows: PropTypes.any,
};

export default withTranslation()(LableIconNav);
